import { DEFAULT_ANCHOR_WAIT_MS } from './constants';

/**
 * Resuelve un selector CSS de forma robusta para SPAs: chequea inmediato
 * y, si no existe, observa el DOM con MutationObserver hasta `timeoutMs`.
 * Devuelve `null` si no apareció antes del timeout.
 *
 * Esta función nunca lanza. Si el selector es inválido devuelve `null`
 * silenciosamente — un selector roto en la DB no debe romper la app.
 */
export function waitForElement(
  selector: string,
  timeoutMs: number = DEFAULT_ANCHOR_WAIT_MS,
): Promise<Element | null> {
  return new Promise((resolve) => {
    const safeQuery = (): Element | null => {
      try {
        return document.querySelector(selector);
      } catch {
        return null;
      }
    };

    const existing = safeQuery();
    if (existing) {
      resolve(existing);
      return;
    }

    let resolved = false;
    const finish = (el: Element | null) => {
      if (resolved) return;
      resolved = true;
      observer.disconnect();
      clearTimeout(timer);
      resolve(el);
    };

    const observer = new MutationObserver(() => {
      const el = safeQuery();
      if (el) finish(el);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const timer = setTimeout(() => finish(null), timeoutMs);
  });
}
